<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ establishment_type.id ? "Editar" : "Novo" }} Tipo de
                Estabelecimento
              </div>
            </div>
            <hr style="margin-top: -4px" />
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="Name">
                        <span class="required">*</span> Nome:
                      </label>
                      <input
                        autocomplete="new-password"
                        type="text"
                        id="Name"
                        class="form-control"
                        v-model="establishment_type.establishment_type_name"
                        placeholder=""
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="inputUser">
                        <span class="required">*</span> Status:
                      </label>
                      <select
                        v-model="establishment_type.status"
                        class="form-control"
                      >
                        <option :value="1">Ativo</option>
                        <option :value="0">Inativo</option>
                      </select>
                    </div>
                  </div>

                  <!-- Editor de campos dinâmicos -->
                  <div class="card mt-3">
                    <div
                      class="card-header d-flex justify-content-between align-items-center py-2"
                    >
                      <span class="font-weight-bold"
                        >Campos do formulário de Estabelecimento</span
                      >
                      <b-button size="sm" variant="success" @click="addField"
                        >+ Adicionar campo</b-button
                      >
                    </div>
                    <div class="card-body p-2">
                      <div
                        v-for="(field, index) in fieldSchema"
                        :key="index"
                        class="border rounded p-2 mb-2 bg-light"
                      >
                        <div class="form-row align-items-end">
                          <div class="form-group col-md-2 mb-1">
                            <label class="small mb-0">Chave (key)</label>
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="field.key"
                              placeholder="ex: cnes"
                            />
                          </div>
                          <div class="form-group col-md-3 mb-1">
                            <label class="small mb-0">Label</label>
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              v-model="field.label"
                              placeholder="ex: CNES"
                            />
                          </div>
                          <div class="form-group col-md-2 mb-1">
                            <label class="small mb-0">Tipo</label>
                            <select
                              class="form-control form-control-sm"
                              v-model="field.type"
                              @change="onFieldTypeChange(field)"
                            >
                              <option value="text">Texto</option>
                              <option value="number">Número</option>
                              <option value="textarea">Textarea</option>
                              <option value="select">Select</option>
                            </select>
                          </div>
                          <div class="form-group col-md-2 mb-1">
                            <label class="small mb-0">Col (Bootstrap)</label>
                            <select
                              class="form-control form-control-sm"
                              v-model="field.col"
                            >
                              <option value="col-md-3">3 (25%)</option>
                              <option value="col-md-4">4 (33%)</option>
                              <option value="col-md-6">6 (50%)</option>
                              <option value="col-md-12">12 (100%)</option>
                            </select>
                          </div>
                          <div class="form-group col-md-2 mb-1">
                            <label class="small mb-0">Obrigatório</label>
                            <select
                              class="form-control form-control-sm"
                              v-model="field.required"
                            >
                              <option :value="false">Não</option>
                              <option :value="true">Sim</option>
                            </select>
                          </div>
                          <div class="form-group col-md-1 mb-1 text-right">
                            <label class="small mb-0 d-block">&nbsp;</label>
                            <b-button
                              size="sm"
                              variant="danger"
                              @click="removeField(index)"
                              >✕</b-button
                            >
                          </div>
                        </div>
                        <!-- Opções do select -->
                        <div v-if="field.type === 'select'" class="mt-2">
                          <label class="small mb-1 font-weight-bold"
                            >Opções do Select</label
                          >
                          <div
                            v-for="(opt, optIndex) in field.options"
                            :key="optIndex"
                            class="d-flex align-items-center mb-1"
                          >
                            <input
                              type="text"
                              class="form-control form-control-sm mr-1"
                              v-model="field.options[optIndex]"
                              :placeholder="'Opção ' + (optIndex + 1)"
                            />
                            <b-button
                              size="sm"
                              variant="outline-danger"
                              @click="field.options.splice(optIndex, 1)"
                              >✕</b-button
                            >
                          </div>
                          <b-button
                            size="sm"
                            variant="outline-secondary"
                            @click="field.options.push('')"
                            >+ Opção</b-button
                          >
                        </div>
                      </div>
                      <p v-if="!fieldSchema.length" class="text-muted small mb-0">
                        Nenhum campo definido. Clique em "+ Adicionar campo"
                        para começar.
                      </p>
                    </div>
                  </div>

                  <span class="required_fields">
                    <span class="required">*</span>
                    <strong>Campos obrigatórios</strong>
                  </span>
                  <div class="block text-right">
                    <router-link
                      to="/establishment_types"
                      class="btn btn-back mr-1"
                    >
                      <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a v-if="$hasAbility('cadastro.gerenciar')" class="btn btn-add" @click="save">
                      Salvar
                      <i class="fa fa-save"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import Loading from "vue-loading-overlay";
import { BButton } from "bootstrap-vue";

export default {
  data() {
    return {
      establishment_type: {
        establishment_type_name: "",
        status: "1",
      },
      fieldSchema: [],
    };
  },
  computed: {},
  methods: {
    addField() {
      this.fieldSchema.push({
        key: "",
        label: "",
        type: "text",
        required: false,
        col: "col-md-6",
        options: [],
      });
    },

    removeField(index) {
      this.fieldSchema.splice(index, 1);
    },

    onFieldTypeChange(field) {
      if (field.type !== "select") {
        field.options = [];
      }
    },

    save: function () {
      const self = this;
      let api = self.$store.state.api + "establishment_types";

      self.establishment_type.field_schema = self.fieldSchema.length
        ? self.fieldSchema
        : null;

      if (self.establishment_type.id) {
        self.establishment_type._method = "PUT";
        api += "/" + self.establishment_type.id;
      }

      self.$loading(true);

      axios
        .post(api, self.establishment_type)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          this.$router.push("/establishment_types");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getEstablishmentType: function (id) {
      const self = this;
      const api = self.$store.state.api + "establishment_types/" + id;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          const data = response.data.data[0];
          self.establishment_type = data;
          self.fieldSchema = data.field_schema || [];
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    let id = self.$route.params.id;
    if (id) {
      self.getEstablishmentType(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
    BButton,
    Loading,
  },
};
</script>
<style scoped>
.custom-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 255, 128, 0);
  backdrop-filter: blur(3px);
  opacity: 0.98;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.custom-loading-spinner {
  width: 100px;
  height: 100px;
  z-index: 10000;
}

.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>